import { render, staticRenderFns } from "./_freePlay.vue?vue&type=template&id=770a23a5&lang=pug&"
import script from "./_freePlay.vue?vue&type=script&lang=js&"
export * from "./_freePlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports